import { UPDATE_BATCH_RESULT } from "./actionTypes"

export const updateBatchResult = () => {
  return {
    type: UPDATE_BATCH_RESULT
  }
}
